import { configureStore } from "@reduxjs/toolkit";
import deletCarReducer from "./car/car-del-slice";
import carReducer from "./car/car-slice";
import deletOperateSlice from "./operate/operate-delete-slice";
import operdonReducer from "./operdon/operdon-slice";
import deleteOperdonReducer from "./operdon/operdon-del-slice";
import userReducer from './user/userSlice';
import carKilometerReducer from "./car/car-kilometer-slice";

const store = configureStore({
  reducer: {
    carList: carReducer,
    carDelete: deletCarReducer,
    operateDelete: deletOperateSlice,
    operdonListCard: operdonReducer,
    operdonDelete: deleteOperdonReducer,
    carKilometer: carKilometerReducer, // ✅ اضافه شد
    user: userReducer,
  },
});

export default store;